module.exports = __webpack_public_path__ + "img/prot-24000.60d734ec.png";